import {googleMap} from "./googleMap";
import "./containSymbol";

export function locationsSearch() {
    const form = $('.location-search form');
    const search = $('.location-search #search');

    function getLocations() {
        let query = search.val();
        locations = [];

        $('.location-item').hide().find('address p').filter(':containsi("' + query + '")').closest('.location-item').show();

        if (query.length) {
            if ($('.location-item:visible').length) {
                $('.locations .no-locations').hide();
                $('.locations .title-results').text($('.location-item:visible').length + ' location(s) near you').show();

            } else {
                $('.locations .title-results').hide();
                $('.locations .no-locations, .location-item').show();
            }
        } else {
            $('.locations .title-results').text('All our locations');
        }

        $('.location-item:visible').each(function () {
            var lat = $(this).attr('data-lat');
            var lng = $(this).attr('data-lng');

            locations.push({lat: parseFloat(lat), lng: parseFloat(lng)});
        });

        jcf.replaceAll();
        googleMap();
    }

    form.on('submit', function (e) {
        e.preventDefault();
        getLocations();
    });

    search.keyup(function () {
        getLocations();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/locationsSearch.js